window.watchlist = () => {
    return {
        _scrollPosition: 0,

        get profiles() {
            return this.$store.watchlist.items.filter(i => i.type === "profile");
        },

        get organizations() {
            return this.$store.watchlist.items.filter(i => i.type === "organization");
        },

        open() {
            this._scrollPosition = window.pageYOffset;
            document.body.classList.add("basicLightbox--enabled");
            document.body.style.top = `-${this._scrollPosition}px`
            this.$el.classList.add("basicLightbox--visible");
        },

        close() {
            document.body.classList.remove("basicLightbox--enabled");
            document.body.style.top = null;
            window.scrollTo({
                top: this._scrollPosition,
                behavior: "instant"
            });
            this.$el.classList.remove("basicLightbox--visible");
        }
    };
};
